import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateService from '../CreateService/CreateService';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import TablePagination from '@mui/material/TablePagination';
import './ServiceList.css';
import { SERVICE_COLOR } from '../../constants';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import EditIcon from '@mui/icons-material/Edit';
import { SERVICE_STATUS } from '../../constants';
import { getTime } from '../../utils';
import { deleteService, fetchProjectList } from '../../store/app/apis';
import Toast from 'light-toast';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import { fetchServiceList } from '../../store/app/apis';

function ServiceList({
  serviceList,
  serviceCount,
  projects,
  name,
  ip,
  status,
  isMobile,
  env,
  stype,
  deleteService,
  fetchServiceList,
  fetchProjectList,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [menuAnchorEl, setmenuAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [page, setPage] = useState(0);
  const [id, setId] = useState('');
  const statusText = {
    [SERVICE_STATUS.SERVICE_UP]: 'UP',
    [SERVICE_STATUS.SERVICE_DOWN]: 'DOWN',
  };
  let navigate = useNavigate();
  const getServiceDetailPage = (event, id) => {
    event.preventDefault();
    navigate(`/dashboard/details/${id}`);
  };
  const handleDialog = () => {
    setmenuAnchorEl(null);
    setOpenConfirmationDialog(true);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClose = (issuccess) => {
    setOpenConfirmationDialog(false);
    if (issuccess) {
      deleteService(id);
    }
  };

  const styles = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      // backgroundColor: 'white',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
    '& .MuiMenu-list': {
      padding: '10px 0px',
    },
  };

  const handleClick = (event, id) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setmenuAnchorEl(null);
    setId(id);
  };

  const handleMenu = (event, id) => {
    setmenuAnchorEl(event.currentTarget);
    setId(id);
  };

  const copyToIdClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
        setmenuAnchorEl(null);
      })
      .catch((error) => {
        Toast.fail('Text not copied!');
        setmenuAnchorEl(null);
      });
  };
  const copyToIpClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
      })
      .catch((error) => {
        Toast.fail('Text not copied!');
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    var payload = {};
    payload['page'] = page + 1;
    payload['size'] = rowsPerPage;
    if (env && env?.length) {
      payload['env'] = env;
    }
    if (projects && projects?.length) {
      payload['project'] = projects;
    }
    if (stype && stype?.length) {
      payload['stype'] = stype;
    }
    if (status && status?.length) {
      payload['status'] = status;
    }
    if (ip && ip !== '') {
      payload['ip'] = ip;
      setPage(0);
      payload['page'] = page + 1;
    }
    if (name && name !== '') {
      payload['name'] = name;
      setPage(0);
      payload['page'] = page + 1;
    }
    fetchServiceList(payload);
  }, [env, name, projects, stype, ip, status, page, rowsPerPage]);
  useEffect(() => {
    var payload2 = {};
    payload2['size'] = 100;
    fetchProjectList(payload2);
  }, []);
  return (
    <div className="tablescroll">
      <div className="tablescrollunderdiv">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Service Name</th>
              <th>IP</th>
              <th>Environment</th>
              <th>Version</th>
              <th>StartTime</th>
              <th>Deploy</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {serviceList?.map((post) => (
              <tr key={post?.id}>
                <td style={{ paddingLeft: '25px', textAlign: 'left' }}>
                  <a
                    href={`/dashboard/details/${post?.id}`}
                    onClick={(event) => {
                      getServiceDetailPage(event, post?.id);
                    }}
                    style={{ textDecoration: 'none' }}
                  >
                    {post?.name}
                  </a>
                </td>
                <td>
                  <span className="tableip">
                    <p className="widthfix">{post?.ip}</p>
                    <Tooltip>
                      <ContentCopyIcon
                        onClick={() => copyToIpClipboard(post?.ip)}
                        sx={{ fontSize: 'small', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  </span>
                </td>

                <td>{post?.env}</td>
                <td>{post?.version}</td>
                <td>{post?.starttime === 0 ? '' : getTime(post?.starttime)}</td>
                <td>{post?.deploy === 0 ? '' : getTime(post?.deploy)}</td>
                <td style={{ color: SERVICE_COLOR[post?.status] }}>{statusText[post?.status]} </td>
                <td>
                  <MoreVertIcon onClick={(event) => handleMenu(event, post?.id)} sx={{ cursor: 'pointer' }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Menu
        sx={styles}
        id="profile-item-menu"
        anchorEl={menuAnchorEl}
        onClose={() => setmenuAnchorEl(null)}
        open={menuAnchorEl != null}
        variant="selectedMenu"
      >
        <MenuItem value={10}>
          <button onClick={() => handleDialog()} className="iconsText">
            <DeleteIcon />
            Delete
          </button>
        </MenuItem>
        <MenuItem value={20}>
          <button onClick={(event) => handleClick(event, id)} className="iconsText">
            <EditIcon />
            Edit
          </button>
        </MenuItem>
        <MenuItem value={30}>
          <button
            onClick={() => copyToIdClipboard(serviceList?.filter((service) => service?.id === id)[0]['id'])}
            className="iconsText"
          >
            <ContentCopyIcon />
            copy
          </button>
        </MenuItem>
      </Menu>
      <TablePagination
        sx={styles}
        rowsPerPageOptions={[10, 15, 25, 50, 100]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        component="div"
        count={serviceCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
      {anchorEl && <CreateService anchorEl={anchorEl} id={id} onClose={handleClick} />}
      {openConfirmationDialog && <ConfirmationDialog closedialog={handleClose} />}
    </div>
  );
}

const mapStateToProps = (state) => ({
  serviceList: state.app.serviceList,
  serviceCount: state.app.serviceCount,
  isMobile: state.app.isMobile,
});
const mapDispatchToProps = { deleteService, fetchServiceList, fetchProjectList };

export default connect(mapStateToProps, mapDispatchToProps)(ServiceList);
